export enum ReportFieldsToSort {
  Address = 27,
  MetroLine = 105,
  CompletionYear = 30,
  EMEAPPTHeader = 25,
  EMEAINTPPTHeader = 280,
}

export enum LocaleKeys {
  default,
  US = 1,
  ChinaChinese = 3,
  ChinaEnglish = 4,
  IndiaEnglish = 5,
  UKEnglish = 7,
  NLEnglish = 8,
  USEnglish = 9,
}

export const disclaimerLang = {
  [LocaleKeys.ChinaChinese]:
    '免责声明:\n以上信息之知识产权均属世邦魏理仕所有，所有权利受法律保护。该信息未经证实，仅供阅读者参考之用。阅读者应当通过法律和其他专业服务进一步验证、核实以上信息。世邦魏理仕不对阅读者和任何第三方使用或依赖以上信息, 或者/以及作出商业决策而导致任何损失和费用或任何其他后果承担任何责任',
  [LocaleKeys.ChinaEnglish]:
    'DISCLAIMER:\nThe intellectual property right of the information in this presentation belongs to CBRE and it shall be protected under applicable laws. The information is only for recipients’ reference and has not been verified. Recipients are advised to inspect and obtain legal and professional advice to verify the information. CBRE shall not be liable for any loss or damage suffered in connection with any use of or reliance on such information.',
};

export const disclaimerFont = {
  [LocaleKeys.ChinaChinese]: 'Arnhem Pro Bln (Body)',
  [LocaleKeys.ChinaEnglish]: 'Arial',
};

export const attributesOrder = {
  [ReportFieldsToSort.Address]: {
    [LocaleKeys.ChinaChinese]: [1, 2, 3, 0],
    [LocaleKeys.ChinaEnglish]: [0, 3, 1, 2],
    [LocaleKeys.USEnglish]: [0, 1, 2, 3],
    [LocaleKeys.IndiaEnglish]: [0, 4, 1, 2, 3],
    [LocaleKeys.UKEnglish]: [0, 1, 2],
    [LocaleKeys.NLEnglish]: [],
  },
  [ReportFieldsToSort.MetroLine]: {
    [LocaleKeys.ChinaChinese]: [1, 2, 0],
    [LocaleKeys.ChinaEnglish]: [2, 1, 0],
  },
  [ReportFieldsToSort.CompletionYear]: {
    [LocaleKeys.ChinaChinese]: [1, 0],
    [LocaleKeys.ChinaEnglish]: [1, 0],
  },
  [ReportFieldsToSort.EMEAPPTHeader]: {
    [LocaleKeys.UKEnglish]: [0, 1, 2, 3],
  },
  [ReportFieldsToSort.EMEAINTPPTHeader]: {
    [LocaleKeys.UKEnglish]: [0, 1, 2, 3],
  },
};
